import {doRequest} from '../../helpers/network';
import {DeltaAnnexure} from '../../helpers/Urls';
import {REQUEST_TYPE} from '../../constants';

export const GET_DELTA_ANNEX_INITIAL_DATA = 'GET_DELTA_ANNEX_INITIAL_DATA';
export const GET_DELTA_ANNEX_INITIAL_DATA_COMPLETED =
  'GET_DELTA_ANNEX_INITIAL_DATA_COMPLETED';
export const GET_DELTA_ANNEX_INITIAL_DATA_FAILED =
  'GET_DELTA_ANNEX_INITIAL_DATA_FAILED';

export const SEARCH_DELTA_ANNEXURES_DETAILS = 'SEARCH_DELTA_ANNEXURES_DETAILS';
export const SEARCH_DELTA_ANNEXURES_DETAILS_COMPLETED =
  'SEARCH_DELTA_ANNEXURES_DETAILS_COMPLETED';
export const SEARCH_DELTA_ANNEXURES_DETAILS_FAILED =
  'SEARCH_DELTA_ANNEXURES_DETAILS_FAILED';

export const PRINT_DELTA_ANNEXURE = 'PRINT_DELTA_ANNEXURE';
export const PRINT_DELTA_ANNEXURE_COMPLETED = 'PRINT_DELTA_ANNEXURE_COMPLETED';
export const PRINT_DELTA_ANNEXURE_FAILED = 'PRINT_DELTA_ANNEXURE_FAILED';

export const DELETE_DELTA_ANNEXURES = 'DELETE_DELTA_ANNEXURES';
export const DELETE_DELTA_ANNEXURES_COMPLETED =
  'DELETE_DELTA_ANNEXURES_COMPLETED';
export const DELETE_DELTA_ANNEXURES_FAILED = 'DELETE_DELTA_ANNEXURES_FAILED';

export const DOWNLOAD_DELTA_ANNEXURES = 'DOWNLOAD_DELTA_ANNEXURES';
export const DOWNLOAD_DELTA_ANNEXURES_COMPLETED =
  'DOWNLOAD_DELTA_ANNEXURES_COMPLETED';
export const DOWNLOAD_DELTA_ANNEXURES_FAILED =
  'DOWNLOAD_DELTA_ANNEXURES_FAILED';

export const VIEW_REGULARISED_ANNEXURE = 'VIEW_REGULARISED_ANNEXURE';
export const VIEW_REGULARISED_ANNEXURE_COMPLETED =
  'VIEW_REGULARISED_ANNEXURE_COMPLETED';
export const VIEW_REGULARISED_ANNEXURE_FAILED =
  'VIEW_REGULARISED_ANNEXURE_FAILED';

export const COMMENT_DELTA_ANNEXURE = 'COMMENT_DELTA_ANNEXURE';
export const COMMENT_DELTA_ANNEXURE_COMPLETED =
  'COMMENT_DELTA_ANNEXURE_COMPLETED';
export const COMMENT_DELTA_ANNEXURE_FAILED = 'COMMENT_DELTA_ANNEXURE_FAILED';

export const SAVE_DELTA_BILL_DETAILS = 'SAVE_DELTA_BILL_DETAILS';
export const SAVE_DELTA_BILL_DETAILS_COMPLETED =
  'SAVE_DELTA_BILL_DETAILS_COMPLETED';
export const SAVE_DELTA_BILL_DETAILS_FAILED = 'SAVE_DELTA_BILL_DETAILS_FAILED';

export const SAVE_DELTA_BILL_SUBMISSION_PROOF_AND_DATE =
  'SAVE_DELTA_BILL_SUBMISSION_PROOF_AND_DATE';
export const SAVE_DELTA_BILL_SUBMISSION_PROOF_AND_DATE_COMPLETED =
  'SAVE_DELTA_BILL_SUBMISSION_PROOF_AND_DATE_COMPLETED';
export const SAVE_DELTA_BILL_SUBMISSION_PROOF_AND_DATE_FAILED =
  'SAVE_DELTA_BILL_SUBMISSION_PROOF_AND_DATE_FAILED';

export const VIEW_BILL_SUBMISSION_PROOF_DETAILS =
  'VIEW_BILL_SUBMISSION_PROOF_DETAILS';
export const VIEW_BILL_SUBMISSION_PROOF_DETAILS_COMPLETED =
  'VIEW_BILL_SUBMISSION_PROOF_DETAILS_COMPLETED';
export const VIEW_BILL_SUBMISSION_PROOF_DETAILS_FAILED =
  'VIEW_BILL_SUBMISSION_PROOF_DETAILS_FAILED';

export const DELTA_ADDN_ANNEXURES_DATA = 'DELTA_ADDN_ANNEXURES_DATA';
export const DELTA_ADDN_ANNEXURES_DATA_COMPLETED =
  'DELTA_ADDN_ANNEXURES_DATA_COMPLETED';
export const DELTA_ADDN_ANNEXURES_DATA_FAILED =
  'DELTA_ADDN_ANNEXURES_DATA_FAILED';

export const DELTA_CN_ANNEXURES_DATA = 'DELTA_CN_ANNEXURES_DATA';
export const DELTA_CN_ANNEXURES_DATA_COMPLETED =
  'DELTA_CN_ANNEXURES_DATA_COMPLETED';
export const DELTA_CN_ANNEXURES_DATA_FAILED = 'DELTA_CN_ANNEXURES_DATA_FAILED';

export const CREATE_ADDITIONAL_ANNEXURE = 'CREATE_ADDITIONAL_ANNEXURE';
export const CREATE_ADDITIONAL_ANNEXURE_COMPLETED =
  'CREATE_ADDITIONAL_ANNEXURE_COMPLETED';
export const CREATE_ADDITIONAL_ANNEXURE_FAILED =
  'CREATE_ADDITIONAL_ANNEXURE_FAILED';

const CLEAR_SEARCH_DELTA_ANNEXURES_DATA = 'CLEAR_SEARCH_DELTA_ANNEXURES_DATA';
const RESET_PAGE = 'RESET_PAGE';

export const DELTA_CREATE_ADHOC_ANNEXURE = 'DELTA_CREATE_ADHOC_ANNEXURE';
export const DELTA_CREATE_ADHOC_ANNEXURE_COMPLETED =
  'DELTA_CREATE_ADHOC_ANNEXURE_COMPLETED';
export const DELTA_CREATE_ADHOC_ANNEXURE_FAILED =
  'DELTA_CREATE_ADHOC_ANNEXURE_FAILED';

export const REMOVE_DELTA_BILL_DETAILS = 'REMOVE_DELTA_BILL_DETAILS';
export const REMOVE_DELTA_BILL_DETAILS_COMPLETED =
  'REMOVE_DELTA_BILL_DETAILS_COMPLETED';
export const REMOVE_DELTA_BILL_DETAILS_FAILED =
  'REMOVE_DELTA_BILL_DETAILS_FAILED';

export const removeDeltaBillDetails = (annexureId) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: REMOVE_DELTA_BILL_DETAILS});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: DeltaAnnexure.removeBillDetailsURL(annexureId),
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: REMOVE_DELTA_BILL_DETAILS_COMPLETED,
          payload: {...data},
        });
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: REMOVE_DELTA_BILL_DETAILS_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: REMOVE_DELTA_BILL_DETAILS_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

const initialState = {
  isFetching: false,
  error: false,
  hasError: false,
  resetPage: false,
  annexuresData: {},
  requestingCommentAnnex: false,
  requestingNextAnnex: false,
  uploadingRevBill: false,
  savingDeltaBillDetails: false,
  annexureInfo: {},
  currentTripRejectData: {},
  deletingAnnex: false,
  isRequestingAnnexure: false,
  printingDeltaAnnex: false,
  updatingRev: false,
  updatingCostRev: false,
  updatingOthers: false,
  sendingForAnnexApproval: false,
  approvingAnnex: false,
  rejectingAnnex: false,
  deletingTripsAnnexure: true,

  isDeltaAnnexureDataFetched: false,
  deltaAnnexureDataInfo: {},
  isDeltaCNAnnexureDataFetched: false,
  deltaCNAnnexureDataInfo: {},
  requestingAddAnnex: false,
  removingDeltaBillDetails: false,
};

export const getDeltaAnnexInitialData = () => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: GET_DELTA_ANNEX_INITIAL_DATA});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: DeltaAnnexure.getDeltaAnnexInitialDataURL(),
      });
      const {data, status} = response || {};
      if (status === true) {
        dispatch({
          type: GET_DELTA_ANNEX_INITIAL_DATA_COMPLETED,
          payload: {...data},
        });
      } else {
        const {message = 'Service Error'} = response || {};
        dispatch({
          type: GET_DELTA_ANNEX_INITIAL_DATA_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: GET_DELTA_ANNEX_INITIAL_DATA_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const searchDeltaAnnexuresData = (
  requestData = {},
  page,
  resetPage = true,
) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: SEARCH_DELTA_ANNEXURES_DETAILS});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: DeltaAnnexure.searchDeltaAnnexuresDataURL(page),
        data: requestData,
      });
      const {data, status} = response || {};
      if (resetPage) {
        dispatch({type: RESET_PAGE});
      }
      if (status === true) {
        dispatch({
          type: SEARCH_DELTA_ANNEXURES_DETAILS_COMPLETED,
          payload: {...data},
        });
      } else {
        const {message = 'Service Error'} = response || {};
        dispatch({
          type: SEARCH_DELTA_ANNEXURES_DETAILS_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: SEARCH_DELTA_ANNEXURES_DETAILS_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const clearSearchDeltaAnnexuresData = () => (dispatch) => {
  dispatch({
    type: CLEAR_SEARCH_DELTA_ANNEXURES_DATA,
  });
};

export const commentDeltaAnnexure = (annexureId, requestData = {}) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: COMMENT_DELTA_ANNEXURE});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: DeltaAnnexure.commentDeltaAnnexureURL(annexureId),
        data: requestData,
      });
      console.log('response --COMMENT_DELTA_ANNEXURE--', response);
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: COMMENT_DELTA_ANNEXURE_COMPLETED,
          payload: {...data},
        });
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: COMMENT_DELTA_ANNEXURE_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: COMMENT_DELTA_ANNEXURE_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const printDeltaAnnexure = (annexureId) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: PRINT_DELTA_ANNEXURE});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: DeltaAnnexure.printDeltaAnnexureURL(annexureId),
      });
      console.log('response --PRINT_DELTA_ANNEXURE--', response);
      const {data, status} = response || {};
      if (status === true) {
        dispatch({
          type: PRINT_DELTA_ANNEXURE_COMPLETED,
          payload: {...data},
        });
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: PRINT_DELTA_ANNEXURE_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: PRINT_DELTA_ANNEXURE_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const deleteDeltaAnnexures = (annexureId) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: DELETE_DELTA_ANNEXURES});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: DeltaAnnexure.deleteDeltaAnnexuresURL(annexureId),
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: DELETE_DELTA_ANNEXURES_COMPLETED,
          payload: {...data},
        });
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: DELETE_DELTA_ANNEXURES_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: DELETE_DELTA_ANNEXURES_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const viewRegularisedAnnexure = (annexureId) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: VIEW_REGULARISED_ANNEXURE});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: DeltaAnnexure.viewRegularisedAnnexureURL(annexureId),
      });
      console.log('response --VIEW_REGULARISED_ANNEXURE--', response);
      const {data, status} = response || {};
      if (status === true) {
        dispatch({
          type: VIEW_REGULARISED_ANNEXURE_COMPLETED,
          payload: {...data},
        });
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: VIEW_REGULARISED_ANNEXURE_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: VIEW_REGULARISED_ANNEXURE_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const saveDeltaBillDetails = (annexureId, requestData = {}) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: SAVE_DELTA_BILL_DETAILS});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: DeltaAnnexure.saveDeltaBillDetailsURL(annexureId),
        data: requestData,
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: SAVE_DELTA_BILL_DETAILS_COMPLETED,
          payload: {...data},
        });
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: SAVE_DELTA_BILL_DETAILS_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: SAVE_DELTA_BILL_DETAILS_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const saveDeltaBillSubmissionProofAndDate = (
  annexureId,
  requestData = {},
) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: SAVE_DELTA_BILL_SUBMISSION_PROOF_AND_DATE});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: DeltaAnnexure.saveDeltaBillSubmissionProofAndDateURL(annexureId),
        data: requestData,
      });

      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: SAVE_DELTA_BILL_SUBMISSION_PROOF_AND_DATE_COMPLETED,
          payload: {...data},
        });
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: SAVE_DELTA_BILL_SUBMISSION_PROOF_AND_DATE_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: SAVE_DELTA_BILL_SUBMISSION_PROOF_AND_DATE_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const viewBillSubmissionProofDetails = (annexureId) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: VIEW_BILL_SUBMISSION_PROOF_DETAILS});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: DeltaAnnexure.viewBillSubmissionProofDetailsURL(annexureId),
      });

      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: VIEW_BILL_SUBMISSION_PROOF_DETAILS_COMPLETED,
          payload: {data},
        });
        return response;
      } else {
        const {message = 'Error fetching proof details'} = response || {};
        dispatch({
          type: VIEW_BILL_SUBMISSION_PROOF_DETAILS_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: VIEW_BILL_SUBMISSION_PROOF_DETAILS_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const downloadDeltaAnnexures = (requestData = {}) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: DOWNLOAD_DELTA_ANNEXURES});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: DeltaAnnexure.downloadDeltaAnnexuresURL(),
        data: requestData,
      });
      console.log('response --DOWNLOAD_DELTA_ANNEXURES--', response);
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: DOWNLOAD_DELTA_ANNEXURES_COMPLETED,
          payload: {...data},
        });
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: DOWNLOAD_DELTA_ANNEXURES_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: DOWNLOAD_DELTA_ANNEXURES_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const deltaAdditionalAnnexureDetails = (annexureId) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: DELTA_ADDN_ANNEXURES_DATA});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: DeltaAnnexure.deltaAdditionalAnnexureDetailsURL(annexureId),
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: DELTA_ADDN_ANNEXURES_DATA_COMPLETED,
          payload: {...data},
        });
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: DELTA_ADDN_ANNEXURES_DATA_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: DELTA_ADDN_ANNEXURES_DATA_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const deltaCNAnnexureDetailsURL = (annexureId, type) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: DELTA_CN_ANNEXURES_DATA});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: DeltaAnnexure.deltaCNAnnexureDetailsURL(annexureId, type),
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: DELTA_CN_ANNEXURES_DATA_COMPLETED,
          payload: {...data},
        });
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: DELTA_CN_ANNEXURES_DATA_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: DELTA_CN_ANNEXURES_DATA_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const createAdditionalAnnexure = (annexureId, requestData = {}) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: CREATE_ADDITIONAL_ANNEXURE});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: DeltaAnnexure.createAdditionalAnnexureURL(annexureId),
        data: requestData,
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: CREATE_ADDITIONAL_ANNEXURE_COMPLETED,
          payload: {...data},
        });
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: CREATE_ADDITIONAL_ANNEXURE_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: CREATE_ADDITIONAL_ANNEXURE_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const deltaCreateAdHocCN = (annexureId, file) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: DELTA_CREATE_ADHOC_ANNEXURE});
      const formData = new FormData();
      formData.append('file', file);
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: DeltaAnnexure.deltaCreateAdHocCNURL(annexureId),
        data: formData,
      });
      const {data, status} = response || {};
      if (status === true) {
        dispatch({
          type: DELTA_CREATE_ADHOC_ANNEXURE_COMPLETED,
          payload: {...data},
        });
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: DELTA_CREATE_ADHOC_ANNEXURE_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: DELTA_CREATE_ADHOC_ANNEXURE_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export default (state = {}, action = {}) => {
  const {type, payload = {}} = action;

  let statePresent = state && Object.keys(state).includes('annexuresData');
  const {annexures} = statePresent && state?.annexuresData;
  let updateAnnx;
  switch (type) {
    case SEARCH_DELTA_ANNEXURES_DETAILS:
      return {
        ...state,
        isFetching: true,
      };
    case SEARCH_DELTA_ANNEXURES_DETAILS_FAILED:
      return {
        ...state,
        isFetching: false,
        error: payload.error,
        hasError: true,
      };
    case SEARCH_DELTA_ANNEXURES_DETAILS_COMPLETED:
      return {
        ...state,
        isFetching: false,
        error: '',
        hasError: false,
        annexuresData: {...payload},
      };
    case CLEAR_SEARCH_DELTA_ANNEXURES_DATA:
      return {
        ...state,
        annexuresData: {},
      };
    case COMMENT_DELTA_ANNEXURE:
      return {
        ...state,
        requestingCommentAnnex: true,
      };
    case COMMENT_DELTA_ANNEXURE_FAILED:
      return {...state, requestingCommentAnnex: false};
    case COMMENT_DELTA_ANNEXURE_COMPLETED:
      updateAnnx = payload.annexure_ids.reduce((acc, curr) => {
        acc[curr] = {
          basicInfo: {
            ...payload.annexures[curr].basicInfo,
          },
        };
        return acc;
      }, {});

      let annexuresCommentData = {
        ...state['annexuresData'],
        annexures: {
          ...state['annexuresData'].annexures,
          ...updateAnnx,
        },
      };

      return {
        ...state,
        requestingCommentAnnex: false,
        annexuresData: annexuresCommentData,
      };
    case PRINT_DELTA_ANNEXURE:
      return {
        ...state,
        printingDeltaAnnex: true,
      };
    case PRINT_DELTA_ANNEXURE_COMPLETED:
      return {
        ...state,
        printingDeltaAnnex: false,
      };
    case PRINT_DELTA_ANNEXURE_FAILED:
      return {
        ...state,
        printingDeltaAnnex: false,
      };
    case DELETE_DELTA_ANNEXURES:
      return {
        ...state,
        deletingDeltaAnnex: true,
      };
    case DELETE_DELTA_ANNEXURES_COMPLETED:
      updateAnnx = payload.annexure_ids.reduce((acc, curr) => {
        acc[curr] = {
          basicInfo: {
            ...payload.annexures[curr].basicInfo,
          },
        };
        return acc;
      }, {});

      let annexuresDeleteData = {
        ...state['annexuresData'],
        annexures: {
          ...state['annexuresData'].annexures,
          ...updateAnnx,
        },
      };

      return {
        ...state,
        deletingDeltaAnnex: false,
        annexuresData: annexuresDeleteData,
      };
    case DELETE_DELTA_ANNEXURES_FAILED:
      return {
        ...state,
        deletingDeltaAnnex: false,
      };
    case DOWNLOAD_DELTA_ANNEXURES:
      return {
        ...state,
        downloadingDeltaAnnexures: true,
      };

    case DOWNLOAD_DELTA_ANNEXURES_COMPLETED:
      updateAnnx = payload.annexure_ids.reduce((acc, curr) => {
        acc[curr] = {
          basicInfo: {
            ...payload.annexures[curr].basicInfo,
          },
        };
        return acc;
      }, {});

      let annexuresDownloadData = {
        ...state['annexuresData'],
        annexures: {
          ...state['annexuresData'].annexures,
          ...updateAnnx,
        },
      };
      return {
        ...state,
        downloadingDeltaAnnexures: false,
        annexuresData: annexuresDownloadData,
      };
    case DOWNLOAD_DELTA_ANNEXURES_FAILED:
      return {
        ...state,
        downloadingDeltaAnnexures: false,
      };
    case SAVE_DELTA_BILL_DETAILS:
      return {
        ...state,
        savingDeltaBillDetails: true,
      };
    case SAVE_DELTA_BILL_DETAILS_COMPLETED:
      updateAnnx = payload.annexure_ids.reduce((acc, curr) => {
        acc[curr] = {
          basicInfo: {
            // ...annexures[curr].basicInfo,
            // bill_number: payload.annexures[curr].basicInfo.bill_number,
            ...payload.annexures[curr].basicInfo,
          },
        };
        return acc;
      }, {});

      let annexuresBillNumberChange = {
        ...state['annexuresData'],
        annexures: {
          ...state['annexuresData'].annexures,
          ...updateAnnx,
        },
      };

      return {
        ...state,
        savingDeltaBillDetails: false,
        annexuresData: annexuresBillNumberChange,
      };
    case SAVE_DELTA_BILL_DETAILS_FAILED:
      return {
        ...state,
        savingDeltaBillDetails: false,
      };
    case GET_DELTA_ANNEX_INITIAL_DATA_COMPLETED: {
      return {
        ...state,
        annexData: payload,
      };
    }

    case DELTA_ADDN_ANNEXURES_DATA:
      return {
        ...state,
        isDeltaAnnexureDataFetched: true,
      };
    case DELTA_ADDN_ANNEXURES_DATA_COMPLETED:
      return {
        ...state,
        isDeltaAnnexureDataFetched: false,
        deltaAnnexureDataInfo: payload,
      };
    case DELTA_ADDN_ANNEXURES_DATA_FAILED:
      return {
        ...state,
        isDeltaAnnexureDataFetched: false,
      };
    case DELTA_CN_ANNEXURES_DATA:
      return {
        ...state,
        isDeltaCNAnnexureDataFetched: true,
      };
    case DELTA_CN_ANNEXURES_DATA_COMPLETED:
      return {
        ...state,
        isDeltaCNAnnexureDataFetched: false,
        deltaCNAnnexureDataInfo: payload,
      };
    case DELTA_CN_ANNEXURES_DATA_FAILED:
      return {
        ...state,
        isDeltaCNAnnexureDataFetched: false,
      };
    case CREATE_ADDITIONAL_ANNEXURE:
      return {
        ...state,
        requestingAddAnnex: true,
      };
    case CREATE_ADDITIONAL_ANNEXURE_COMPLETED:
      return {
        ...state,
        requestingAddAnnex: false,
      };
    case CREATE_ADDITIONAL_ANNEXURE_FAILED:
      return {
        ...state,
        requestingAddAnnex: false,
      };

    // case RESET_PAGE:
    //   return {...state, resetPage: !state.resetPage};

    // ----------------- -------------------------
    case DELTA_CREATE_ADHOC_ANNEXURE_COMPLETED: {
      const updatedAnnexures = (payload.annexure_ids || []).reduce(
        (acc, id) => {
          if (payload.annexures?.[id]) {
            acc[id] = {
              basicInfo: {
                ...payload.annexures[id].basicInfo,
              },
            };
          }
          return acc;
        },
        {},
      );
      return {
        ...state,
        isCreatingAdHocAnnexure: false,
        annexuresData: {
          ...state.annexuresData,
          annexures: {
            ...state.annexuresData?.annexures,
            ...updatedAnnexures,
          },
        },
      };
    }
    case DELTA_CREATE_ADHOC_ANNEXURE:
      return {
        ...state,
        isCreatingAdHocAnnexure: true,
      };
    case DELTA_CREATE_ADHOC_ANNEXURE_FAILED:
      return {
        ...state,
        isCreatingAdHocAnnexure: false,
      };
    // ----------------- -------------------------

    case REMOVE_DELTA_BILL_DETAILS:
      return {
        ...state,
        removingDeltaBillDetails: true,
      };
    case REMOVE_DELTA_BILL_DETAILS_COMPLETED: {
      const updatedAnnexures = (payload.annexure_ids || []).reduce(
        (acc, id) => {
          if (payload.annexures?.[id]) {
            acc[id] = {
              basicInfo: {
                ...payload.annexures[id].basicInfo,
              },
            };
          }
          return acc;
        },
        {},
      );
      return {
        ...state,
        removingDeltaBillDetails: false,
        annexuresData: {
          ...state.annexuresData,
          annexures: {
            ...state.annexuresData?.annexures,
            ...updatedAnnexures,
          },
        },
      };
    }
    case REMOVE_DELTA_BILL_DETAILS_FAILED:
      return {
        ...state,
        removingDeltaBillDetails: false,
      };

    default: {
      if (payload.trips) {
        return {...state, ...payload.trips};
      }
      return state;
    }
  }
};
